export interface OnboardingTask {
  order: number;
  key: OnboardingTaskKey;
  status: OnboardingTaskStatus;
}

export enum OnboardingTaskKey {
  InviteMembers = 'INVITE_MEMBERS',
  CreatePayoutAccount = 'CREATE_PAYOUT_ACCOUNT',
  CreateSale = 'CREATE_SALE',
}

export enum OnboardingTaskStatus {
  Pending = 'PENDING', // awaiting completion
  Disabled = 'DISABLED', // when dependent tasks are not completed
  Completed = 'COMPLETED', // when task is completed
}
